import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeUser } from "../redux/reducers";
import NumberFormat from "react-number-format";

const ID = () => {
  const { user } = useSelector((state) => state);
  const dispatch = useDispatch();


  return (
    <div class="container">
      <form aria-invalid aria-errormessage>
        <p>Hi {user.name} 🖐</p>
        <p>This is your ID key</p>
        <br />
        <NumberFormat format="# # # # # # # " mask="_" value={user.ID} readOnly />
        <input
          placeholder="log Out"
          style={{ paddingLeft: "32%", cursor: "pointer" }}
          readOnly
          onClick={() => dispatch(removeUser(user))}
        />
        <br />
        <br />
      </form>

      <div class="drops">
        <div class="drop drop-1"></div>
        <div class="drop drop-2"></div>
        <div class="drop drop-3"></div>
        <div class="drop drop-4"></div>
        <div class="drop drop-5"></div>
      </div>
    </div>
  );
};

export default ID;
